import { NavTabs } from "src/components/ui/NavTabs";

import { useAppState } from "src/state";

export function OperationsAdminVenueAreaTabs({
    overlay = false
}: React.PropsWithChildren<{
    overlay?: boolean
}>): React.ReactElement {

    const { currentItemId } = useAppState(state=>state.areas)

    return ( 
        <NavTabs
            overlay={overlay}
            parentId={currentItemId}
            urlRoot={`/areas`}
            tabs={{
                details: {
                    label: 'Area Overview',
                    icon: 'home',
                    route: ''
                },
                guidelines: {
                    label: 'Area Guidelines',
                    icon: 'guideline',
                    route: 'guidelines'
                }
            }}
        />
    )

}